<!-- help-center-edit.component.html -->
<div class="edit-page-container">

  <!-- Loading -->
  <div *ngIf="loading" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <!-- 頁面頂部 -->
  <div class="page-header">
    <h1 class="page-title">{{ pageTitle }}</h1>
    <div class="header-actions">
      <button *ngIf="canEdit && !isEditing"
              pButton
              class="p-button-sm"
              icon="pi pi-pencil"
              [label]="'HelpCenter.Editing.Label.Edit' | translate"
              (click)="toggleEdit()">
      </button>
      <button *ngIf="isEditing"
              pButton
              class="p-button-sm p-button-secondary"
              icon="pi pi-eye"
              [label]="'HelpCenter.Editing.Label.View' | translate"
              (click)="toggleEdit()">
      </button>
    </div>
  </div>

  <!-- 主佈局：左右分割 -->
  <div class="edit-page-layout">

    <!-- 左側編輯器區 -->
    <div class="editor-section">

      <!-- 檢視模式 -->
      <div *ngIf="!isEditing" class="view-mode">
        <div #viewPreviewContent class="view-content" [innerHTML]="dockPreviewHtml"></div>
      </div>

      <!-- 編輯模式 -->
      <div *ngIf="isEditing" class="edit-mode">
        <laas-editor
          [ngModel]="initialContent"
          (ngModelChange)="onEditorChange($event)"
          [style]="{ height: 'calc(100vh - 240px)' }"
          [permissionCode]="permissionCode">
        </laas-editor>
      </div>

      <!-- 編輯模式：底部操作按鈕 -->
      <div *ngIf="isEditing" class="edit-actions">
        <button pButton
                class="p-button-info"
                [label]="'HelpCenter.Editing.Button.SaveDraft' | translate"
                [disabled]="isDraftSaved"
                (click)="saveDraft()">
        </button>
        <button pButton
                class="p-button-success"
                [label]="'HelpCenter.Editing.Button.Publish' | translate"
                [disabled]="isDraftSaved && isReleaseSaved"
                (click)="saveRelease()">
        </button>
      </div>
    </div>

    <!-- 右側預覽區 -->
    <div class="preview-section">
      <div class="preview-header">
        <i class="pi pi-eye"></i>
        <span>{{ 'HelpCenter.Editing.Label.DockDisplayEffect' | translate }}</span>
      </div>

      <div class="preview-container">
        <div class="mock-dock">
          <div #dockPreviewContent class="mock-dock-content" [innerHTML]="dockPreviewHtml"></div>
        </div>
      </div>

      <div class="preview-footer">
        <i class="pi pi-info-circle"></i>
        <span>{{ 'HelpCenter.Editing.Label.PreviewDescription' | translate }}</span>
      </div>
    </div>

  </div>
</div>
